import { get } from "lodash";

const styles = (theme) => ({
    content: {
      margin: 36,
      minHeight: 'calc(100vh - 125px)',
      backgroundColor: get(theme, 'color.uiBackground'),
      marginTop: 0,
      padding: '24px 0px 36px 0px',
    },
    linkHover: {
      cursor: 'pointer',
    },
});

export default styles;